import { createContext } from "react";
import { User } from "consumerhouse-shared";
import { ConsumerHouseClient } from "./api";

export interface AuthContextType {
    refreshToken: string;
    accessToken: string;
    user: User;
}

export interface AuthContextState {
    auth: AuthContextType | null;
    setAuth: (val: AuthContextType | null) => void;
    client: ConsumerHouseClient;
}

const AuthContext = createContext<AuthContextState>({} as any);

export default AuthContext;
